<template>
  <div
    class="year-icon"
  >
    <span>{{ yearLabel.substring(0, 2) }}</span>
    <span>{{ yearLabel.substring(2) }}</span>
  </div>
</template>
<script>
export default {
  name: 'YearIcon',
  props: {
    year: {
      type: Number,
      required: false,
      default: null,
    },
  },
  computed: {
    yearLabel() {
      return this.year ? this.year.toString() : this.$getCollectionById(this.$store.state.theme).year.toString();
    },
  },
};
</script>
<style lang="stylus" scoped>
.year-icon {
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  line-height: 0.72
  font-size: 10px
  width: 10px;

  & > span:first-child {
    padding-bottom: 1px;
  }
}
</style>
